import React from "react"

const Dribbble = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g id="Dribbble-group" transform="translate(-1 -1)">
      <circle
        id="Ellipse_2"
        data-name="Ellipse 2"
        cx="10"
        cy="10"
        r="10"
        transform="translate(2 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_7186"
        data-name="Path 7186"
        d="M8.56,2.75c4.37,6.03,6.02,9.42,8.03,17.72M19.13,5.09c-3.72,4.35-8.94,5.66-16.88,5.85m19.5,1.9a15.406,15.406,0,0,0-8.94,0c-2.58.92-5.01,2.86-7.44,6.32"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default Dribbble
